import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionLessonMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        instituteSubjectMasterId: '',
        sectionLessonName: ['']
    }
    const [lessonData, setLessonData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "sectionLessonName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getLessonList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (lessonData.sectionSyllabusStructureMasterId.length !== 0 && lessonData.instituteSubjectMasterId.length !== 0) {
                setLessonList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(lessonList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(lessonList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > lessonList.length) {
            endIndex = lessonList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(lessonList.slice(startIndex, endIndex));
    }, [lessonList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `get-section-lesson-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (lessonData.sectionSyllabusStructureMasterId !== '') {
            apiUrl += `sectionSyllabusStructureMasterId=${lessonData.sectionSyllabusStructureMasterId}&`;
        }
        if (lessonData.instituteSubjectMasterId !== '') {
            apiUrl += `instituteSubjectMasterId=${lessonData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getLessonList = async () => {
        if (lessonData.sectionSyllabusStructureMasterId.length !== 0 && lessonData.instituteSubjectMasterId.length !== 0) {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setLessonList(response.data.result);
            } catch (error) {
                setLessonList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    useEffect(() => {
        getLessonList();
    }, [lessonData.instituteSubjectMasterId]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setLessonData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
            }
        })
        const apiUrl = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e, index) => {
        setLessonData((prevData) => {
            if (e.target.name === 'sectionLessonName') {
                const updatedLessonName = [...prevData.sectionLessonName];
                updatedLessonName[index] = e.target.value;
                return {
                    ...prevData,
                    sectionLessonName: updatedLessonName,
                };
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddLesson = () => {
        setLessonData((prevData) => ({
            ...prevData,
            sectionLessonName: [...prevData.sectionLessonName, ''],
        }));
    };

    const handleRemoveLesson = (index) => {
        setLessonData((prevData) => {
            const updatedLessonName = [...prevData.sectionLessonName];
            updatedLessonName.splice(index, 1);
            return {
                ...prevData,
                sectionLessonName: updatedLessonName,
            }
        });
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noErrors = Object.values(error).every((error) => error === '');

        const allValuesValid = Object.entries(lessonData).every(([key, value]) => {
            if (key === 'sectionLessonName' && Array.isArray(value)) {
                return value.every(lesson => typeof lesson === 'string' && lesson.trim() !== '');
            } else {
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(lessonData)) {
                if (key === "sectionLessonName") {
                    for (const lesson of lessonData.sectionLessonName) {
                        if (lesson == '' || lesson.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                sectionLessonName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: ''
                                }
                            });
                        }
                    }
                } else if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [lessonData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-lesson-master`;
                const response = await authorizedAxiosSection.post(apiUrl, lessonData);
                await getLessonList();
                setLessonData((prevData) => {
                    return {
                        ...prevData,
                        sectionLessonName: [''],
                    };
                })

                setSaveId(response.data.result[0].id);
                setSyllabusNameSort(null);
                setSubjectNameSort(null);
                setLessonNameSort(null);
                setSearchValue(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(lessonData)) {
                if (key === "sectionLessonName") {
                    for (const lesson of lessonData.sectionLessonName) {
                        if (lesson == '' || lesson.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                sectionLessonName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '') {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-lesson-master?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, lessonList.length);
                await getLessonList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateLesson = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-section-lesson-master?id=${editId}`;
            const response = await authorizedAxiosSection.put(apiUrl, lessonData);
            await getLessonList();
            setEditId(null);
            setLessonData((prevData) => {
                return {
                    ...prevData,
                    sectionLessonName: [''],
                };
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setLessonList([]);
        setEditId('');
        setLessonData(initialFormState);
        setError(initialErrorState);
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setSyllabusNameSort(null);
            setLessonNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusNameSort(null);
            setSubjectNameSort(null);
        }
    }, [lessonNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Lesson</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Lesson Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={lessonData.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Subject<span style={{ color: "red" }}>*</span>  :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleInputChange} value={lessonData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                {lessonData?.sectionLessonName?.map((lesson, index) => (
                                                    <>
                                                        <div className="col-md-5">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Lesson Name :</label>
                                                            <input type="text" className="form-control" id={`sectionLessonName${index}`} name='sectionLessonName' onChange={(e) => handleInputChange(e, index)} value={lesson} />
                                                            {error.sectionLessonName && lesson == "" && <p style={{ color: 'red' }}>{error.sectionLessonName}</p>}

                                                        </div>
                                                        {lessonData.sectionLessonName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Lesson Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addLesson}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"sectionLessonName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.sectionSyllabusStructureMasterDetails?.sectionSyllabusStructureName}</td>
                                                                                        <td>{lesson.instituteSubjectMasterDetails.subjectName}</td>
                                                                                        <td>{lesson.sectionLessonName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setLessonData({
                                                                                                    instituteMasterId: instituteMasterId.toString(),
                                                                                                    sectionMasterId: sectionMasterId.toString(),
                                                                                                    sectionSyllabusStructureMasterId: lesson.sectionSyllabusStructureMasterDetails?.id.toString(),
                                                                                                    sectionLessonName: [lesson.sectionLessonName],
                                                                                                    instituteSubjectMasterId: lesson.instituteSubjectMasterDetails.id.toString()
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === lesson.id} onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lesson Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={lessonList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionLessonMaster;